import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { Skeleton, Typography } from "@mui/material";
import React from "react";
import "./TextNavigate.css";
import { useStableNavigate } from "@mirage/hooks/useStableNavigate";

interface TextNavigateProps {
    navigateTo?: string | null;
    children?: React.ReactNode;
    disabled?: boolean;
    isLoading?: boolean;
    onClick?: () => void;
    style?: React.CSSProperties;
}

export const TextNavigate: React.FC<TextNavigateProps> = ({ children, navigateTo, isLoading, disabled = false, onClick, style }) => {
    const navigate = useStableNavigate();
    const disabledClass = disabled ? "-disabled" : "";

    if (!children) {
        return null;
    }

    if (isLoading) {
        return <Skeleton variant="text" sx={{ maxWidth: "300px", marginBottom: "1rem" }} />;
    }
    return (
        <Typography variant="button" className={`textNavigate${disabledClass}`.trim()} style={{ color: MirageTheme.palette.primary.main, ...style }} onClick={handleOnClick}>
            {children}
        </Typography>
    );

    function handleOnClick() {
        if (onClick) {
            onClick();
            return;
        }
        if (navigateTo) {
            navigate(navigateTo);
        }
    }
};
